import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P420List({ dataTable, setAction }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (rowData = null) => setAction(rowData);

    const colorColumn = (rowData, checkColumn, titleShow) => {
        let data = { ...rowData };
        let datavalue = data[`${checkColumn}`];
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                <div style={{ marginLeft: 20, height: 30, backgroundColor: "#" + datavalue }}></div>
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <DataTable
                // ref={(el) => dt = el}
                value={dataTable}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูล"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >
                <Column field="colorSeq" header="ลำดับ" sortable body={(e) => normalColumn(e, "colorSeq", "ลำดับ")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="percentMin" header="เปอร์เซ็นต์จาก" body={(e) => normalColumn(e, "percentMin", "เปอร์เซ็นต์จาก")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="percentMax" header="เปอร์เซ็นถึง" body={(e) => normalColumn(e, "percentMax", "เปอร์เซ็นถึง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="colorValue" header="สี" body={(e) => colorColumn(e, "colorValue", "สี")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="updateUserName" header="ผู้แก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้แก้ไข")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="updateDt" header="วันเวลาแก้ไข" body={(e) => normalColumn(e, "updateDt", "วันเวลาแก้ไข")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column header="แก้ไข" field="photoPath" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
            </DataTable>
        </div>
    );
}
